export interface Publication {
  id: number;
  title: string;
  author?: string;
  publisher: string;
  year: string;
  type: 'Book' | 'Journal Article' | 'Magazine Publication' | 'Gazette' | 'Essay' | 'Catalogue' | 'Curatorial Publication';
  topic: string[];
  abstract: string;
  coverImage?: string;
  additionalImages?: string[];
  isbn?: string;
  doi?: string;
  pages?: string;
  amazonUrl?: string;
  buyNowUrl?: string;
  requestCopy?: boolean;
}

export const publications: Publication[] = [
  {
    id: 1,
    title: 'Oniru Gazette (Publication On-Going)',
    publisher: 'Wildeye Creative Solutions LTD',
    year: '2023',
    type: 'Gazette',
    topic: ['Royal Heritage', 'Lagos History', 'Governance'],
    abstract: 'As Editor-in-Chief of Oniru Gazette, Oludamola Adebowale leads a publication dedicated to documenting socio-cultural and political developments within the Iru Kingdom, including Victoria Island and its environs. The gazette provides a structured historical record of the reign of His Royal Majesty, Oba Abdulwasiu Omogbolahan Lawal, Abisogun II, preserving institutional memory and contemporary heritage.',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/0f808cf5-94ab-468a-b99b-636ca7890249_Oniru-Gazzette-1.jpg?v=22d44c26420753142cecf2f6cc641126',
    additionalImages: [
      'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/5a96e2ee-28b3-4b23-a6bf-acfa45d5b2ce_Oniru-Gazzette-2.jpg?v=8e13b20b468eda8e4a2bc15c5ec65fd2',
    ],
    pages: '120',
  },
  {
    id: 2,
    title: "The Fabric of a Nation: Essays on Nigeria's History, Arts and Culture",
    publisher: 'Wildeye Creative Solutions LTD',
    year: '2025',
    type: 'Book',
    topic: ['Nigeria History', 'Culture', 'Arts', 'Heritage'],
    abstract: 'The Fabric of a Nation is a profound collection of essays that explores Nigeria\'s historical, artistic, and cultural evolution. In this work, Oludamola Adebowale presents a compelling narrative that connects pre-colonial histories to modern identities. Through detailed research and reflective writing, the book positions culture and memory as essential threads in understanding Nigeria\'s national consciousness.',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/9016b940-85c6-42dd-86f5-7215c2d8afb6_FOAN-1.jpg?v=54c7334558c2cf8ca125b2b13d9448f2',
    additionalImages: [
      'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/ca0ebc45-bed0-48bc-b28b-4d24b50add4a_FOAN-2.jpg?v=32314ba3f954c804a1022b426151522b',
    ],
    pages: '188',
    isbn: '979-8272448095',
    amazonUrl: 'https://www.amazon.co.uk/Fabric-Nation-Nigerias-History-Culture-ebook/dp/B0FYZ46PTR/ref=sr_1_1?crid=1SY8J1HC01K7Y&dib=eyJ2IjoiMSJ9.lBvku_byg7gC9bGbWgYKMA.mr4J9OCdkI0ew8I8SW8GW7odZdKZnHMfIaGUgshiA1o&dib_tag=se&keywords=fabric+of+a+nation+oludamola&qid=1775985118&s=books&sprefix=fabric+of+a+nation+oludamol%2Cstripbooks%2C224&sr=1-1',
  },
  {
    id: 3,
    title: 'History of Lagos',
    publisher: 'Wildeye Creative Solutions LTD',
    year: '2021',
    type: 'Book',
    topic: ['Lagos History', 'Urban History', 'Colonial History'],
    abstract: 'History of Lagos is a curated compilation of historical writings originally published on ASIRI Magazine. Developed to mark the platform\'s 10-year anniversary in collaboration with the RV Foundation, the work brings together key narratives that document Lagos\' evolution. It serves as both an educational resource and a preservation effort for the city\'s dynamic past.',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/8e36c3a9-bd59-48bf-8fdc-2a6fb245fb68_History-of-Lagos1.jpeg?v=096f8a1884eb386f8b093c7a5d07182e',
    additionalImages: [
      'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/0b7bdf06-82bc-4e6b-995d-12136ab0585a_History-of-Lagos2.jpeg?v=f04519326c5fe87d7d30d48821cfe957',
    ],
    pages: '412',
    requestCopy: true,
  },
  {
    id: 4,
    title: 'Timeless Memories: Conversation Between Wole Soyinka And Ulli Beier',
    publisher: 'Wildeye Creative Solutions LTD',
    year: '2020',
    type: 'Book',
    topic: ['Literary History', 'Cultural Exchange', 'Nigerian Literature'],
    abstract: 'Timeless Memories captures a series of intimate conversations between Wole Soyinka and Ulli Beier, reflecting on art, culture, and shared intellectual history. Presented during the 2021 LABAF festival, the compilation highlights their enduring contributions to Nigerian cultural discourse, with Oludamola Adebowale contributing to the broader archival and conceptual framing of the project.',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/9e2bf58d-9247-4e5f-a8a1-b686f1a43373_Timeless-Memories-Cover.jpg?v=808037f779d1cb038f0a9662a12f20ce',
    additionalImages: [
      'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/fc96a3e7-bc4d-41a7-851d-e56970c963c9_Timeless-memory-cover-design-with-name.jpg?v=f28b071c9007779a90f5098ecd804052',
    ],
    pages: '196',
    requestCopy: true,
  },
  {
    id: 5,
    title: 'Guardian Life Magazine: 5 Years of Cultural Influence',
    publisher: 'Wildeye Creative Solutions LTD',
    year: '2019',
    type: 'Magazine Publication',
    topic: ['Cultural Journalism', 'Arts & Lifestyle', 'Media History'],
    abstract: 'Over a five-year period, Oludamola Adebowale contributed extensively to Guardian Life Magazine, focusing on arts, culture, and historical narratives. His writings explored critical themes such as gender, identity, and heritage, with notable essays gaining academic recognition. His ground breaking articles on topics like Women Arise in the face of Misogyny: A Cultural and Historical Perspective; Jaja of Opobo: Rivers of Oil and Blood; Re-Discovering the Benin Art: A Universal Vessel for Cultural Importance; \u00c0B\u00cdK\u00da: A Thin Line that cuts between Tradition and Science, have been cited by Academic scholars within and outside Nigeria.',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/30411fbf-54dd-4d4f-a97d-59448fa2d407_Guardian-Life-Magazine.jpg?v=6cae08757f8c82dc97339c5ef3ecf017',
    pages: '88',
  },
  {
    id: 10,
    title: "Who's Who in the Yoruba Pantheon",
    author: 'Peju Akande, Toni Kan, Jahman Anikulapo',
    publisher: 'iwalewabooks',
    year: '2020',
    type: 'Book',
    topic: ['Yoruba Culture', 'Traditional Religion', 'Cultural Heritage'],
    abstract: "Who's Who in the Yor\u00f9b\u00e1 Pantheon reexamines traditional understandings of the orishas, presenting them through a contemporary and culturally grounded lens. Oludamola was one of the experts on Yor\u00f9b\u00e1 culture and Traditional religion that was consulted alongside Prof. Wale Adeniran, Oloye Muraina Oyelami, and Chief Priest Ifayemi Elebuibon. Published by the Goethe Institut Nigeria, 2021.",
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/c88bfe98-8046-459d-bf82-e898be8b60ca_WHO-IS-WHO.jpg?v=85890022b5ccbdf81f3a7fcb14f068ec',
    pages: '208',
    isbn: '978-3-947902-17-0',
  },
  {
    id: 7,
    title: "In the Beginning there was Cloth: Textures of Identity: Afrikstabel's Fabric of Change",
    publisher: 'Wildeye Creative Solutions LTD',
    year: '2025',
    type: 'Curatorial Publication',
    topic: ['Nigeria Textile', 'Fashion History', 'Adire', 'Ulli'],
    abstract: 'In the Beginning There Was Cloth: Textures of Identity: Afrikstabel\'s Fabric of Change is a compelling exploration of fabric not merely as material, but as a living archive of culture, identity, and transformation. Through its pages, cloth becomes language—woven with memory, resistance, and evolving expressions of Afrikstabel\'s vision for change. As both editor and writer, Oludamola carefully threads together diverse narratives, offering a textured reflection on how textiles shape, and are shaped by, the identities they adorn. This work invites readers to see beyond the surface, into the intricate patterns of history, creativity, and meaning embedded within every strand.',
    coverImage: 'https://storage.readdy-site.link/project_files/4630a528-7d86-42ab-a7d2-89b69416f273/1534cc73-9931-4117-8dd7-268ae167160b_In-the-Beginning-there-was-Cloth.jpeg?v=db2f20ed5acc2dbec51f4ee6551e3f01',
    pages: '340',
  },
];

export const publicationYears = [...new Set(publications.map((p) => p.year))].sort((a, b) => Number(b) - Number(a));
export const publicationTypes = [...new Set(publications.map((p) => p.type))];
export const publicationTopics = [...new Set(publications.flatMap((p) => p.topic))].sort();
